// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './root'
import { Route as authRoutesLoginRouteImport } from './auth/routes/login'
import { Route as inventoryRoutesLayoutRouteImport } from './inventory/routes/layout'
import { Route as inventoryRoutesRootRedirectRouteImport } from './inventory/routes/root-redirect'
import { Route as authRoutesSsoIssueRouteImport } from './auth/routes/sso-issue'
import { Route as authRoutesSsoConsumeRouteImport } from './auth/routes/sso-consume'
import { Route as inventoryRoutesIndexRouteImport } from './inventory/routes/index'
import { Route as inventoryRoutesUnitsRouteImport } from './inventory/routes/units'
import { Route as inventoryRoutesSettingsRouteImport } from './inventory/routes/settings'
import { Route as inventoryRoutesReceiveRouteImport } from './inventory/routes/receive'
import { Route as inventoryRoutesProductsRouteImport } from './inventory/routes/products'
import { Route as inventoryRoutesExportRouteImport } from './inventory/routes/export'
import { Route as inventoryRoutesUnitDetailRouteImport } from './inventory/routes/unit-detail'

const authRoutesLoginRoute = authRoutesLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const inventoryRoutesLayoutRoute = inventoryRoutesLayoutRouteImport.update({
            id: '/_inventory-layout',getParentRoute: () => rootRouteImport
          })
const inventoryRoutesRootRedirectRoute = inventoryRoutesRootRedirectRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const authRoutesSsoIssueRoute = authRoutesSsoIssueRouteImport.update({
            id: '/sso/issue',path: '/sso/issue',getParentRoute: () => rootRouteImport
          })
const authRoutesSsoConsumeRoute = authRoutesSsoConsumeRouteImport.update({
            id: '/sso/consume',path: '/sso/consume',getParentRoute: () => rootRouteImport
          })
const inventoryRoutesIndexRoute = inventoryRoutesIndexRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => inventoryRoutesLayoutRoute
          })
const inventoryRoutesUnitsRoute = inventoryRoutesUnitsRouteImport.update({
            id: '/inventory/units',path: '/inventory/units',getParentRoute: () => inventoryRoutesLayoutRoute
          })
const inventoryRoutesSettingsRoute = inventoryRoutesSettingsRouteImport.update({
            id: '/inventory/settings',path: '/inventory/settings',getParentRoute: () => inventoryRoutesLayoutRoute
          })
const inventoryRoutesReceiveRoute = inventoryRoutesReceiveRouteImport.update({
            id: '/inventory/receive',path: '/inventory/receive',getParentRoute: () => inventoryRoutesLayoutRoute
          })
const inventoryRoutesProductsRoute = inventoryRoutesProductsRouteImport.update({
            id: '/inventory/products',path: '/inventory/products',getParentRoute: () => inventoryRoutesLayoutRoute
          })
const inventoryRoutesExportRoute = inventoryRoutesExportRouteImport.update({
            id: '/inventory/export',path: '/inventory/export',getParentRoute: () => inventoryRoutesLayoutRoute
          })
const inventoryRoutesUnitDetailRoute = inventoryRoutesUnitDetailRouteImport.update({
            id: '/inventory/units/$unitId',path: '/inventory/units/$unitId',getParentRoute: () => inventoryRoutesLayoutRoute
          })





const inventoryRoutesLayoutRouteChildren = {
  inventoryRoutesIndexRoute: inventoryRoutesIndexRoute,inventoryRoutesExportRoute: inventoryRoutesExportRoute,inventoryRoutesProductsRoute: inventoryRoutesProductsRoute,inventoryRoutesReceiveRoute: inventoryRoutesReceiveRoute,inventoryRoutesSettingsRoute: inventoryRoutesSettingsRoute,inventoryRoutesUnitsRoute: inventoryRoutesUnitsRoute,inventoryRoutesUnitDetailRoute: inventoryRoutesUnitDetailRoute
}

const inventoryRoutesLayoutRouteWithChildren = inventoryRoutesLayoutRoute._addFileChildren(inventoryRoutesLayoutRouteChildren)

const rootRouteChildren = {
  inventoryRoutesRootRedirectRoute: inventoryRoutesRootRedirectRoute,inventoryRoutesLayoutRoute: inventoryRoutesLayoutRouteWithChildren,authRoutesLoginRoute: authRoutesLoginRoute,authRoutesSsoConsumeRoute: authRoutesSsoConsumeRoute,authRoutesSsoIssueRoute: authRoutesSsoIssueRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)